// PreviewTester/utils/tourStorage.js

const TOUR_KEY = 'preview_tester_tour_completed';

export const isTourCompleted = () => {
  try {
    return localStorage.getItem(TOUR_KEY) === 'true';
  } catch {
    return false;
  }
};

export const markTourCompleted = () => {
  try {
    localStorage.setItem(TOUR_KEY, 'true');
    return true;
  } catch {
    return false;
  }
};

export const resetTour = () => {
  try {
    localStorage.removeItem(TOUR_KEY);
    return true;
  } catch {
    return false;
  }
};